import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var CaseToBeStudiedItem = function (props) {
    var i18n = props.i18n, caseToBeStudied = props.caseToBeStudied;
    var description = getPropsByKeyPath(i18n, 'modules.timeline.caseToBeStudied.textAction');
    return (_jsx(_Fragment, { children: _jsx("p", { children: description }) }));
};
